import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from './Sidebar';
import DashboardHeader from './DashboardHeader';


export const Underdevloped = () => {

    const navigate = useNavigate();

    useEffect(() => {
        // Check if token exists in local storage
        const token = localStorage.getItem("NCD_token") || localStorage.getItem("sickle_token") || localStorage.getItem("PMNDP_token") || localStorage.getItem("NIKSHAY_valid_user") || localStorage.getItem("uwin_token");
        if (!token) {
            navigate("/");
        }
    }, [navigate]); // run on mount

    return (
        <>

            <div className='underDevelopedPage py-3'>
                <div className='container-fluid'>
                    <div className="  align-items-center justify-content-center">
                        <img src={"/images/under-development.svg"} alt="" className='img-responsive' style={{ width: "100%", height: "80vh" }} />
                    </div>
                </div>
            </div>

            <div className="footer justify-content-center" style={{ margin: 0 }}>
                <p>
                    © All rights reserved by Ministry of Health & Family Welfare,
                    Government of India.
                </p>
            </div>
        </>
    )
}
